import React from "react";
import { useFormik } from "formik";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { classNames } from "primereact/utils";
import { Dialog } from "primereact/dialog";
import "./style.scss";
import { addMeter, getMeters } from "../../services";
import { useDispatch, useSelector } from "react-redux";
import { showSuccessMessage, updateUserMeters } from "../../redux/action";

const CreateMeter = (props) => {
  const dispatch = useDispatch();
  const {meters} = useSelector((state) => state.redux.userInfo);

  const isAlreadyExistsNumber = (number) =>{
    return meters.find((ele) => ele.number === number);
  };
  const isAlreadyExistsLabel = (label) =>{
    return meters.find((ele) => ele.label === label);
  };
  const formik = useFormik({
    initialValues: {
      label: "",
      number: ""
    },
    validate: (data) => {
      let errors = {};
      if (!data.label) {
        errors["label"] = "label is required";
      }else if (isAlreadyExistsLabel(data.label)){
        errors["label"] = "meter label already exists";
      }
      if (!data.number) {
        errors["number"] = "number is required";
      }else if (isAlreadyExistsNumber(data.label)){
        errors["number"] = "meter number already exists";
      }

      return errors;
    },
    onSubmit: (data) => {
        addMeter(data).then((response) =>{
            dispatch(showSuccessMessage("Meter added successfully"));
            setTimeout(() =>{
                dispatch(showSuccessMessage(""));
            },500);

            getMeters().then((meters) =>{
                dispatch(updateUserMeters(meters.data));
            })

            props.closeAdd();
        })
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const cancelAdd = () => {
    formik.resetForm();
    props.closeAdd();
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        header={"Add Meter"}
        visible={true}
        style={{ width: "50vw" }}
        footer={null}
        onHide={() => cancelAdd()}
      >
        <form onSubmit={formik.handleSubmit} className="p-fluid row">
          <div className="field mb-3">
            <label
              htmlFor="label"
              className={classNames({
                "p-error": isFormFieldValid("label"),
              })}
            >
              Label *
            </label>
            <span className="p-inputgroup">
              <InputText
                name="label"
                value={formik.values.label}
                onChange={formik.handleChange}
                autoFocus
                className={classNames({
                  "p-invalid": isFormFieldValid("label"),
                })}
              />
            </span>
            {getFormErrorMessage("label")}
          </div>

          <div className="field mb-3">
            <label
              htmlFor="number"
              className={classNames({
                "p-error": isFormFieldValid("number"),
              })}
            >
              Number *
            </label>
            <span className="p-inputgroup">
              <InputText
                name="number"
                value={formik.values.number}
                onChange={formik.handleChange}
                autoFocus
                className={classNames({
                  "p-invalid": isFormFieldValid("number"),
                })}
              />
            </span>
            {getFormErrorMessage("number")}
          </div>

          <Button type="submit" label="Submit" className="mt-2" />
        </form>
      </Dialog>
    </div>
  );
};

export default CreateMeter;
